module.exports = __webpack_public_path__ + "static/media/halona-picturemark-d.1d3dcf67.svg";